var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"raised-box p-box"},[_c('SimpleForm',{attrs:{"onSubmit":_vm.onSubmit,"fields":[
				{
					label : 'Template name',
					name : 'name',
					autocomplete : 'template-name',
					autofocus : true,
					required : true,
				},
				{
					label : 'Organisation',
					name : 'org_id',
					type : 'org',
					required : true,
				},
				{
					label : 'Template',
					name : 'templateData',
					type : 'template',
					autofocus : true,
					required : true,
				} ],"model":_vm.template,"submitBlock":_vm.submitBlock,"submitText":"Save Template"}})],1),_vm._v(" "),_c('div',{staticClass:"raised-box p-box s-above",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","border-top":"3px solid red"}},[_c('i',{staticClass:"far fa-trash-alt c-warning",staticStyle:{"margin-right":"10px"}}),_vm._v(" Delete this template: "),_c('button',{class:{'btn-warning':1,'_btn_submitting':_vm.deleting},staticStyle:{"margin":"10px"},on:{"click":_vm.deleteTemplate}},[_vm._v("Delete template")])])])}
var staticRenderFns = []

export { render, staticRenderFns }